import { Fragment, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import _ from 'lodash';
import { detailCustomerAtom } from '../../atoms/customer';
import { defaultAuth } from '../../atoms/auth';
import { Loading } from '../../widgets';
import { notificationAtom } from '../../atoms/system';
import { useAtom, useSetAtom } from 'jotai';
import { ICustomerDetail } from '../../inter/detail';
import produce from 'immer';
import { IResponse, CommentType } from '../../types';
import api from '../../api';
import { useImmer } from 'use-immer';

const Detail = (): JSX.Element => {
  const notification = useSetAtom(notificationAtom);
  const [showDetailCustomer, setShowDetailCustomer] =
    useAtom(detailCustomerAtom);
  const [loading, setLoading] = useImmer<boolean>(false);
  const [detailData, setDetailData] = useImmer<ICustomerDetail | null>(null);
  useEffect(() => {
    if (showDetailCustomer.customer_id.length > 0 && showDetailCustomer.show) {
      (async () => {
        try {
          setLoading(true);
          const result = await api
            .get(`api/customers/${showDetailCustomer.customer_id}`)
            .json<IResponse<ICustomerDetail | null>>();
          if (_.isNull(result.data)) {
            throw Error();
          }
          setDetailData(result.data);
          setLoading(false);
        } catch (e) {
          console.log(e);
          notification({
            show: true,
            type: null,
            title: null,
          });
        }
      })();
    }
  }, [showDetailCustomer.customer_id]);
  return (
    <>
      <Transition show={showDetailCustomer.show} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[999]"
          onClose={() =>
            setShowDetailCustomer(
              produce(draft => {
                draft.show = false;
                draft.customer_id = '';
              }),
            )
          }
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg transform overflow-hidden p-4 rounded-xl bg-white shadow-xl transition-all">
                  {loading || _.isNull(detailData) ? (
                    <div className="flex justify-center items-center min-h-screen">
                      <Loading color="indigo-600" size={6} />
                    </div>
                  ) : (
                    <div className="flex flex-col space-y-2">
                      <h3 className="text-md font-medium text-gray-900">
                        Chi tiết tương tác của khách hàng
                        <p className="text-sm font-normal text-gray-700">
                          ({showDetailCustomer.info.name} -{' '}
                          {showDetailCustomer.info.email})
                        </p>
                      </h3>
                      <div className="space-y-2">
                        {detailData.counts.map((item, i) => {
                          let title = '';
                          switch (item.type) {
                            case CommentType.review:
                              title = 'đánh giá';
                              break;
                            case CommentType.question:
                              title = 'câu hỏi';
                              break;
                            case CommentType.replyReview:
                              title = 'trả lời đánh giá';
                              break;
                            case CommentType.replyQuestion:
                              title = 'trả lời câu hỏi';
                              break;
                          }
                          return (
                            <span className="text-sm text-gray-600 font-medium">
                              {i > 0 ? ' / ' : ''}
                              {item._count} {title}
                            </span>
                          );
                        })}
                        <p></p>
                      </div>
                      <h3 className="text-md font-medium text-gray-900">
                        Các sản phẩm đã tương tác
                      </h3>
                      <div className="space-y-2">
                        {detailData.product_list.map(item => (
                          <a
                            href={`${defaultAuth?.myharavan_domain}/products/${item.handle}`}
                            className="text-sm block text-blue-600"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {item.title}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default Detail;
